export default __webpack_public_path__ + "static/media/B15VR.58606c7a.jpg";